import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/company-profile/import-hub')({
  async beforeLoad({ context, location }) {
    const isExternalDataFeature = await context.isFlagEnabled(
      '@myn/secured',
      'externalDataFeature',
    );
    if (isExternalDataFeature) {
      const newPath = location.pathname.replace(
        '/company-profile/import-hub',
        '/external-data/import-hub',
      );
      throw redirect({
        to: newPath,
        search: location.search,
      });
    }

    const hasVewPermission = await context.hasPermission(
      'dataManagementHubFeature:view',
    );
    if (!hasVewPermission) {
      throw notFound();
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/import-hub');
    const title = i18n.t('Import Hub | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
